import { TableContainer, TablePagination } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { SearchBar } from "components/Common/SearchBar"
import { useAppSelector } from "hooks"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import authService from "services/authService"
import type { IDevice } from "types/deviceTypes"
import { UserRoles } from "types/userRoles"
import { DeviceListItemMenu } from "./DeviceListItemMenu"

export function DeviceList() {
  const [roles, setRoles] = useState<Array<string>>()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [searchText, setSeachText] = useState<string>("")
  const navigate = useNavigate()

  const devices = useAppSelector((state) => state.device.devices)

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const filterDevices = (value: string, devices: Array<IDevice>): Array<IDevice> => {
    const filteredDevices = devices.filter((device) => {
      return device.name.toLowerCase().includes(value.toLowerCase())
    })

    return filteredDevices
  }

  useEffect(() => {
    authService.getRolesAssignedToUser().then((roles) => {
      setRoles(roles)
    })
  }, [])

  return (
    <TableContainer>
      <SearchBar onChange={(value: string) => setSeachText(value)} />
      <div style={{ minHeight: "280px" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Id</TableCell>
              <TableCell align="right" padding="checkbox"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterDevices(searchText, devices)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((device, _index) => (
                <TableRow
                  key={device.id}
                  hover={roles?.includes(UserRoles.HIAB_ADMIN)}
                  onClick={() => {
                    if (roles?.includes(UserRoles.HIAB_ADMIN)) {
                      navigate(device.id)
                    }
                  }}
                >
                  <TableCell>{device.name}</TableCell>
                  <TableCell>{device.id}</TableCell>
                  <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                    <DeviceListItemMenu device={device} />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        component="div"
        rowsPerPageOptions={[5, 10, 25]}
        count={filterDevices(searchText, devices).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  )
}
